export const UNKNOWN_LABEL = 'Unknown';
export const APP_NAME = 'ImmunoSense';
export const APP_TAGLINE = 'Antibody sequence analysis and prioritization for faster candidate selection.';
export const APP_STATUS = 'Early access';
export const BUILD_DETAIL_ENVIRONMENTS = ['develop', 'development', 'test'];
// NODE_ENV is 'development' only under the local dev server, not in a bundled deployment.
export const SHOW_BUILD_DETAILS =
  process.env.NODE_ENV === 'development' || BUILD_DETAIL_ENVIRONMENTS.includes((process.env.REACT_APP_ENVIRONMENT ?? '').trim());

export const TITLE_MAX_LENGTH = 60;
export const DESCRIPTION_MAX_LENGTH = 255;

export const validateTitle = (value: string): string | null => {
  if (!value?.length) {
    return 'Title is required';
  }
  if (value.length > TITLE_MAX_LENGTH) {
    return `Title must be ${TITLE_MAX_LENGTH} characters or fewer`;
  }
  return null;
};

export const validateDescription = (value: string): string | null =>
  (value?.length ?? 0) > DESCRIPTION_MAX_LENGTH ? `Description must be ${DESCRIPTION_MAX_LENGTH} characters or fewer` : null;
